<div id="soft_alert4" class="soft_alert"><p>Hinweis: Bitte achten Sie auf die korrekte Eingabe Ihrer Daten, da diese für
    die Rechnungsstellung (z.B. für Ihre Steuererklärung) verwendet werden.</p>
</div>
